module.exports = __webpack_public_path__ + "img/plane-containers.1686001f.png";